import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewDataEntryPagesGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.DATA_ENTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewImportExportDataEntryPagesGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.execute,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EXPORT_DATA,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageDataEntryPagesGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.DATA_ENTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageMonitoringMetricPagesGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.MANAGE_MONITORING_METRICS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewBenchmarkDataEntryGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.BENCHMARK_DATA_ENTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageBenchmarkDataEntryGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.BENCHMARK_DATA_ENTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
